/** Same defaults as send-invoice-reminders: 7 days, then every 7, at most 3. */

export interface ReminderSchedule {
  enabled?: boolean;
  days_until_first_reminder?: number;
  reminder_interval_days?: number;
  max_reminders?: number;
}

function addDays(isoDate: string, days: number): string | null {
  const [year, month, day] = isoDate.slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) return null;
  const date = new Date(Date.UTC(year, month - 1, day + days));
  const dd = String(date.getUTCDate()).padStart(2, '0');
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${dd}-${mm}-${date.getUTCFullYear()}`;
}

/** Read-only next reminder day, dd-mm-yyyy. Null when no further reminder is planned. */
export function nextReminderLabel(input: {
  dueAt: string | null | undefined;
  sentCount: number;
  lastSentAt: string | null | undefined;
  settings?: ReminderSchedule | null;
}): string | null {
  const settings = input.settings ?? {};
  if (settings.enabled === false || !input.dueAt) return null;
  const max = settings.max_reminders ?? 3;
  if (input.sentCount >= max) return null;
  const first = settings.days_until_first_reminder ?? 7;
  const interval = settings.reminder_interval_days ?? 7;
  if (input.sentCount === 0) return addDays(input.dueAt, first);
  if (!input.lastSentAt) return null;
  return addDays(input.lastSentAt, interval);
}
